import { render, staticRenderFns } from "./LogisticsDetail.vue?vue&type=template&id=1634263f&scoped=true"
import script from "./LogisticsDetail.vue?vue&type=script&lang=js"
export * from "./LogisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDetail.vue?vue&type=style&index=0&id=1634263f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634263f",
  null
  
)

export default component.exports